// Brouillons de mesure non enregistrés, sur cet appareil seulement (docs/mesure/mesure-satellite.md, tâche 9).
// Un brouillon est isolé par utilisateur ET par contrat ou adresse : il ne passe jamais d'une adresse à une autre
// ni d'une personne à la suivante. Il est retiré après un enregistrement réussi, quand on l'ignore, et à la
// déconnexion. Le stockage peut être absent ou plein (navigation privée) : tout échec est silencieux, la carte
// reste utilisable sans brouillon. Ce n'est pas un mode hors ligne.

const prefix = 'reca.zoneDraft.v1:'

export interface StoredZoneDraft<TData> {
  version: 1
  savedAt: string
  /** Révision de la mesure sur laquelle repose le brouillon : reprise refusée si elle a changé. */
  baseRevision: number
  /** Nombre de zones, pour le résumé de la bannière. */
  zoneCount: number
  data: TData
}

export function zoneDraftKey(userId: string, scope: string): string {
  return `${prefix}${userId}:${scope}`
}

function storage(): Storage | null {
  try {
    return typeof window === 'undefined' ? null : window.localStorage
  } catch {
    return null
  }
}

export function readZoneDraft<TData>(key: string): StoredZoneDraft<TData> | null {
  try {
    const raw = storage()?.getItem(key)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<StoredZoneDraft<TData>>
    if (parsed.version !== 1 || typeof parsed.baseRevision !== 'number' || parsed.data === undefined)
      return null
    return parsed as StoredZoneDraft<TData>
  } catch {
    return null
  }
}

export function writeZoneDraft<TData>(
  key: string,
  draft: Omit<StoredZoneDraft<TData>, 'version' | 'savedAt'>,
): void {
  try {
    storage()?.setItem(key, JSON.stringify({ version: 1, savedAt: new Date().toISOString(), ...draft }))
  } catch {
    // Stockage plein ou refusé : le brouillon n'est simplement pas conservé.
  }
}

export function removeZoneDraft(key: string): void {
  try {
    storage()?.removeItem(key)
  } catch {
    // Rien à retirer.
  }
}

/** Déconnexion : aucun brouillon ne reste pour la personne suivante sur l'appareil. */
export function clearZoneDrafts(): void {
  const store = storage()
  if (!store) return
  try {
    const keys: string[] = []
    for (let index = 0; index < store.length; index += 1) {
      const key = store.key(index)
      if (key?.startsWith(prefix)) keys.push(key)
    }
    for (const key of keys) store.removeItem(key)
  } catch {
    // Stockage inaccessible : rien n'a pu y être écrit non plus.
  }
}
